import { FormData, Pitch } from "../contexts/Constants";

export const getFormFromPitch = (pitch: Pitch): FormData => {
  return {
    id: pitch.id,
    staff: pitch.staff,
    businessName: pitch.businessName,
    contactName: pitch.contactName,
    position: pitch.position,
    contactType: pitch.contactType,
    phone: pitch.phone,
    email: pitch.email,
    website: pitch.website,
    country: pitch.country,
    street: pitch.street,
    city: pitch.city,
    state: pitch.state,
    postCode: pitch.postCode,
    dms: pitch.dms,
    ledUsage: pitch.ledUsage,
    status: pitch.status,
    reminderDuration: pitch.reminderDuration,
    contactSentiment: pitch.contactSentiment,
    note: pitch.note,
  };
};

export const toTitleCase = (str: String): string => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const changeOpacity = (hex: string, opacity: number) => {
  if (/^#?[0-9a-fA-F]{3}$/.test(hex)) {
    hex = hex.replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (_, r, g, b) => "#" + r + r + g + g + b + b
    );
  }

  hex = hex.replace(/^#/, "");

  const alpha = Math.round(Math.min(1, Math.max(0, opacity)) * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0");

  return `#${hex}${alphaHex}`;
};
